import axios from "axios";

const API_URL = '/OppPortal/api/v1/submissions/';

class SubmissionService {

    initPortal(name, published) {
        return axios.get(API_URL + `${name}/init?published=${published}`)
    }

    initSubmission(portal, prefilledValues) {
        if (Object.keys(prefilledValues).length !== 0) {
            return axios.post(API_URL +`${portal.name}/submission/init`, portal, { params : prefilledValues})
        } else {
            return axios.post(API_URL +`${portal.name}/submission/init`, portal)
        }
    }

    submit(name, data, mapFiles) {
        let formData = new FormData();
        Object.keys(mapFiles).forEach(key => {
            const files = mapFiles[key]
            files.forEach(file => {
                formData.append('files', file);
            });
        })
        formData.append('data', new Blob([JSON.stringify(data)], {
            type: "application/json"
        }));
        return axios.post(API_URL + `${name}/submission`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }

    findObjectsByQuery(id, linkedClass, query, isNG) {
        return axios.get(API_URL + `clients/${id}/objects/${linkedClass}/${query}?isNG=${isNG}`);
    }
}

export default new SubmissionService();